module.exports = __webpack_public_path__ + "static/img/IN.14d0d09f.png";